import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ModalShareComponent } from 'src/app/shared/components/measure-card/modal-share/modal-share.component';
import { ResearchService } from '../research.service';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-research-detail',
  templateUrl: './research-detail.component.html',
  styleUrls: ['./research-detail.component.scss']
})
export class ResearchDetailComponent implements OnInit {

  researchID;
  researchDetail;
  researchWave;
  type: string = 'research';

  constructor(
    public matDialog: MatDialog,
    private researchService: ResearchService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    this.researchID = new URL(location.href).searchParams.get('research_id');

    this.researchService.getlDetailResearchByMeasure(this.researchID).pipe(
      map(res => {
        if (res.success) {

          if (!res.result[0].PROGRESS.status_consent) {
            window.open('/research/research-consent?research_id=' + this.researchID + '&INVITER=' + '', '_self');

          } else if (!res.result[0].PROGRESS.status_sceen) {
            window.open('/research/research-screen-question?research_id=' + this.researchID, '_self');

          } else {
            this.researchDetail = res.result[0];
            this.researchWave = this.researchDetail.MEASURES;
            // // console.log(this.researchDetail)
            this.gobalFunctionService.setTitle(this.researchDetail.RESEARCH_NAME);
          }
        }
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(null);
      })
    ).subscribe();
  }

  share() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalRegister';
    dialogConfig.width = '550px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'Share',
      actionBtnText: 'ปิด',
      link: this.researchDetail.LINK,
    }

    const modal = this.matDialog.open(ModalShareComponent, dialogConfig);
    modal.afterClosed().subscribe()
  }

}
